import { Injectable } from '@angular/core';
import { MobileContactsService } from '@contacts/feature';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { MobileMenuNavigationService } from '@core/feature';
import { RoutingService } from '@spartacus/core';
import { combineLatest, map, Observable } from 'rxjs';
import { TabBarActiveItem } from './tab-bar-active-item.const';

@Injectable({ providedIn: 'root' })
export class TabBarActiveItemService {
  constructor(
    private routingService: RoutingService,
    private mobileContactsService: MobileContactsService,
    private mobileMenuNavigationService: MobileMenuNavigationService,
  ) {}

  getActiveItem(): Observable<TabBarActiveItem | null> {
    return combineLatest({
      routingState: this.routingService.getRouterState(),
      isMobileContactsOpened: this.mobileContactsService.isOpen$,
      isMobileMenuOpened: this.mobileMenuNavigationService.isMenuOpened(),
    }).pipe(
      map(({ routingState, isMobileContactsOpened, isMobileMenuOpened }) => {
        if (isMobileContactsOpened) {
          return 'contacts';
        }

        if (routingState.state.url.includes('/my-account') || routingState.state.semanticRoute === 'login') {
          return 'account';
        }

        if (routingState.state.semanticRoute === 'cart') {
          return 'cart';
        }

        if (isMobileMenuOpened) {
          return 'menu';
        }

        return null;
      }),
    );
  }
}
